import {SummonDataProperty} from 'src/tracker/model/property/summon/summon-data-property'

export const diabolosProperty = new SummonDataProperty(
  "4d33ee25-3317-42f3-b31c-644ec8a2f649",
  "Diabolos",
)
